<template>
  <div>
    <div class="filter-item geoDistanceFilter w-100 mb-2">
      <span
        v-show="(geoDistance?.location.latitude !== 0 || geoDistance?.location.longitude !== 0) && geoDistance?.kilometers !== 0"
        class="geoDistanceClearBtn" @click="clearGeoDistance"><i class="far fa-times" title="Borrar GeoDistancia"></i></span>
      <label for="geoDistanceDetails">GeoDistancia</label>
      <div id="geoDistanceDetails" class="geoDistanceDetails" @click="openModal">
        <div class="geoDistance_detail row m-0 border rounded-sm">
          <span class="rounded-left bg-light text-left">Latitud</span>
          <p class="col m-0 py-1 px-2 rounded-right bg-white text-muted">{{ geoDistance?.location.latitude || 0 }}</p>
        </div>
        <div class="geoDistance_detail row m-0 border rounded-sm">
          <span class="rounded-left bg-light text-left">Longitud</span>
          <p class="col m-0 py-1 px-2 rounded-right bg-white text-muted">{{ geoDistance?.location.longitude || 0 }}</p>
        </div>
        <div class="geoDistance_detail row m-0 border rounded-sm">
          <span class="rounded-left bg-light text-left">Radio</span>
          <p class="col m-0 py-1 px-2 rounded-right bg-white text-muted">{{ geoDistance?.kilometers || 0 }} Km</p>
        </div>
      </div>
    </div>
    <FillgridGeoDistanceFilterModal ref="modalRef" id="geoDistanceModal" @geoDistance="updateGeoDistance"></FillgridGeoDistanceFilterModal>
  </div>
</template>

<script>
import { Component, Vue, Model } from 'vue-property-decorator'
import FillgridGeoDistanceFilterModal from './FillgridGeoDistanceFilterModal.vue'

@Component({
  components: {
    FillgridGeoDistanceFilterModal
  }
})
export default class FillgridGeoDistanceFilter extends Vue {
  @Model('change') geoDistance

  openModal () {
    const modal = document.getElementById('geoDistanceModal')
    modal.showModal()
    this.$refs.modalRef.resize()
  }

  closeModal () {
    const modal = document.getElementById('geoDistanceModal')
    modal.close()
  }

  updateGeoDistance (geoDistance) {
    this.$emit('change', geoDistance)
  }

  clearGeoDistance () {
    this.$emit('change', { location: { latitude: 0, longitude: 0 }, kilometers: 0 })
  }
}
</script>

<style scoped>
.geoDistanceFilter {
  position: relative;
}
.geoDistanceDetails {
  cursor: pointer;
}
.geoDistanceDetails > .geoDistance_detail > span {
  padding: 0.25rem 0.5rem;
  min-width: 9ch;
}
.geoDistanceClearBtn {
  position: absolute;
  display: none;
  justify-content: center;
  align-items: center;
  top: 1.5rem;
  right: -0.1rem;
  width: 1.25rem;
  height: 1.25rem;
  background-color: var(--danger);
  color:  var(--white);
  border-radius: 50%;
  cursor: pointer;
  font-size: 0.9rem;
  z-index: 2;
}
.geoDistanceFilter:hover > .geoDistanceClearBtn {
  display: flex;
}
.geoDistanceFilter:hover > .geoDistanceClearBtn:hover {
  filter: brightness(1.1);
}
</style>
